import { Link } from 'react-router-dom';
import './app-footer.css';

const policyLinks = [
  ['/legal/terms', 'Terms & Conditions'],
  ['/legal/privacy', 'Privacy Policy'],
  ['/legal/refund-cancellation', 'Refunds & Cancellations'],
  ['/legal/delivery-fulfilment', 'Shipping & Delivery'],
  ['/legal/contact', 'Contact Us'],
  ['/legal/grievance', 'Grievance Support'],
] as const;

/** Shared by login, guest ordering and signed-in routes; never depends on session state. */
export default function AppFooter() {
  return (
    <footer className="bw-app-footer" aria-label="Business and policies">
      <div className="bw-app-footer__inner">
        <p className="bw-app-footer__identity">
          <strong>BITEWISE TECH PRIVATE LIMITED</strong>
          <span>BiteWise is operated by BITEWISE TECH PRIVATE LIMITED.</span>
        </p>
        <nav aria-label="Policies and contact">
          {policyLinks.map(([to, label]) => <Link key={to} to={to}>{label}</Link>)}
          <Link to="/">About BiteWise</Link>
          <Link to="/website-settings">Website Settings</Link>
          <Link to="/legal/rewards">Rewards Policy</Link>
          <Link to="/legal/delete-account">Account Deletion</Link>
        </nav>
        <p className="bw-app-footer__support">
          <a href="mailto:support@bitewise.co.in">support@bitewise.co.in</a>
          <a href="tel:+918800613349">+91 88006 13349</a>
        </p>
      </div>
    </footer>
  );
}
